var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bottom-block"},[_c('div',{staticClass:"footer"},[_c('p',[_vm._v("© 2019 Alinouski Aliaksei. All right reserved ©.\n\t\t\t\t\t")]),_c('p',[_c('a',{attrs:{"href":"termsofuse.html"}},[_vm._v("Terms of use")]),_vm._v(" "),_c('a',{attrs:{"href":"privacypolicy.html"}},[_vm._v("Privacy policy")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73b0ee3a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = 68
// module chunks = 0